import * as globalConstants from './globalConstants';

export const {
  METHODS_WITH_BODY,
  ENVS_WITH_LOG_ENABLE,
  EMAIL_REGEX,
  REDIRECT_PATHS,
  mimeToFileTypeMapping,
  ROLES,
  BASE_TODOS,
  getBaseTodos,
  STATUS_OPTIONS,
} = globalConstants;

export default globalConstants;
